import axios from 'axios';
import { polusBaseUrl, uwBaseUrl, POST } from '../../../utils/axios-interceptor';
import { getTimeStamp } from '../../../utils/dateUtils';
import { BankStatementRangePayload, BsaReportWindow } from './types';

// BSA report generation is a single blocking call that runs the full
// fetch->compute->render->upload pipeline server-side (can take minutes for
// large orgs) — disable the default axios timeout so the client doesn't abort
// the request before the backend responds.
const BSA_REPORT_GENERATE_TIMEOUT_MS = 900000;

// startDate/endDate are included ONLY when both are set — a one-sided or absent range must
// keep today's exact body: {requestId, csv: false}, no date keys at all.
export function fetchBankStatementDataService(payload?: BankStatementRangePayload) {
    const hasRange = !!(payload?.startDate && payload?.endDate);
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.FETCH_BANK_STMT_DATA,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            csv: false,
            ...(hasRange && { startDate: payload!.startDate, endDate: payload!.endDate }),
        },
    });
}

// Single blocking call: UW invokes the report-generation lambda synchronously
// and only responds once the file is generated and uploaded — no polling.
// reportWindow is omitted entirely (never null/{}) when no Time Period range is applied.
export function bsaGenerateService(investeeOrgId: string, reportWindow?: BsaReportWindow) {
    return axios({
        baseURL: uwBaseUrl,
        url: API_ENDPOINTS.BSA_REPORT_GENERATE,
        method: POST,
        data: { investeeOrgId, ...(reportWindow && { reportWindow }) },
        timeout: BSA_REPORT_GENERATE_TIMEOUT_MS,
    });
}

const API_ENDPOINTS = {
    FETCH_BANK_STMT_DATA: '/data/bankStatementData',
    BSA_REPORT_GENERATE: '/bank/bsa-report/generate',
};
